import React, { useMemo } from 'react';

import styles from './CurrentStepIndicator.module.scss';

const CurrentStepIndicator = ({ numberOfSteps = 1, currentStep = 1, handleChangeStep = () => {} }) => {
  const indicators = useMemo(() => {
    const indicatorsList = [];
    for (let i = 1; i <= numberOfSteps; i += 1) {
      indicatorsList.push(
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <button
          key={`step-${i}`}
          className={currentStep === i ? styles.filledCircle : styles.hollowCircle}
          type="button"
          onClick={() => handleChangeStep(i)}
        />
      );
    }
    return indicatorsList;
  }, [currentStep, numberOfSteps]);

  return <div className={styles.rootContainer}>{indicators}</div>;
};

export default CurrentStepIndicator;
